import camelize from 'camelize'
import { useGeckoAuth } from 'features/auth'
import { RolodexContext } from 'features/rolodex'
import { useContext } from 'react'
import useSWR from 'swr'
import { RolodexUserMetadata } from 'types'

export const useRolodexPermissionsAllUserMetadata = () => {
  const { isAuthenticated, authorizedAxios: axios } = useGeckoAuth()
  const { apiURL } = useContext(RolodexContext)

  const { data, isLoading } = useSWR<RolodexUserMetadata[], string>(
    isAuthenticated ? `${apiURL}/api/v2/permissions/user-metadata/all` : null,
    async (url: string) => {
      if (!url) {
        return Promise.resolve(null)
      }
      const response = await axios.get(url, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      return camelize(response.data)
    }
  )

  const geckoUsers = (data || []).filter((user) =>
    user.roles.find((r) => r.name === 'gecko:internal:member')
  )

  return {
    data: geckoUsers,
    isLoading,
  }
}
